import { render, staticRenderFns } from "./modal_evidence.vue?vue&type=template&id=a26c7e12&scoped=true"
import script from "./modal_evidence.vue?vue&type=script&lang=js"
export * from "./modal_evidence.vue?vue&type=script&lang=js"
import style0 from "./modal_evidence.vue?vue&type=style&index=0&id=a26c7e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26c7e12",
  null
  
)

export default component.exports